"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StorageService = void 0;
var StorageService = exports.StorageService = (function () {
    function StorageService() {
    }
    StorageService.instance = function () {
        return StorageService.INSTANCE;
    };
    StorageService.prototype.getCookieValue = function (cookiename) {
        var re = new RegExp("[; ]" + cookiename + "=([^\\s;]*)");
        var sMatch = (" " + document.cookie).match(re);
        if (cookiename && sMatch) {
            return decodeURI(sMatch[1]);
        }
        return "";
    };
    StorageService.prototype.getFeatureLoggingState = function () {
        return (this.getCookieValue(StorageService.FEATURE_LOGGING_COOKIE_NAME) === "true");
    };
    StorageService.prototype.getLogAggregationState = function () {
        var _a;
        var featureToggle = (_a = window.LaCommons) === null || _a === void 0 ? void 0 : _a.config.feature.logAggregation;
        var cookieValue = this.getCookieValue(StorageService.LOG_AGGREGATION_COOKIE_NAME) ===
            "true";
        return featureToggle || cookieValue;
    };
    StorageService.FEATURE_LOGGING_COOKIE_NAME = "featureLogging";
    StorageService.LOG_AGGREGATION_COOKIE_NAME = "logAggregation";
    StorageService.INSTANCE = new StorageService();
    return StorageService;
}());
